module.exports = __webpack_public_path__ + "img/pro_three_2.492dd6a4.jpg";